import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import { CustomFormsModule } from 'ng2-validation'
import {ToasterModule, ToasterService} from 'angular2-toaster';
import { AuthService } from './core/auth/auth.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'
import * as moment from 'moment';
declare const gapi: any;


@NgModule({
    declarations: [AppComponent],
    exports: [
	    CdkTableModule,
	    CdkTreeModule,
	    MatAutocompleteModule,
	    MatBadgeModule,
	    MatBottomSheetModule,
	    MatButtonModule,
	    MatButtonToggleModule,
	    MatCardModule,
	    MatCheckboxModule,
	    MatChipsModule,
	    MatStepperModule,
	    MatDatepickerModule,
	    MatDialogModule,
	    MatDividerModule,
	    MatExpansionModule,
	    MatGridListModule,
	    MatIconModule,
	    MatInputModule,
	    MatListModule,
	    MatMenuModule,
	    MatNativeDateModule,
	    MatPaginatorModule,
	    MatProgressBarModule,
	    MatProgressSpinnerModule,
	    MatRadioModule,
	    MatRippleModule,
	    MatSelectModule,
	    MatSidenavModule,
	    MatSliderModule,
	    MatSlideToggleModule,
	    MatSnackBarModule,
	    MatSortModule,
	    MatTableModule,
	    MatTabsModule,
	    MatToolbarModule,
	    MatTooltipModule,
	    MatTreeModule,
	],
    imports: [
    	CdkTableModule,
	    CdkTreeModule,
	    MatAutocompleteModule,
	    MatBadgeModule,
	    MatBottomSheetModule,
	    MatButtonModule,
	    MatButtonToggleModule,
	    MatCardModule,
	    MatCheckboxModule,
	    MatChipsModule,
	    MatStepperModule,
	    MatDatepickerModule,
	    MatDialogModule,
	    MatDividerModule,
	    MatExpansionModule,
	    MatGridListModule,
	    MatIconModule,
	    MatInputModule,
	    MatListModule,
	    MatMenuModule,
	    MatPaginatorModule,
	    MatProgressBarModule,
	    MatProgressSpinnerModule,
	    MatRadioModule,
	    MatRippleModule,
	    MatSelectModule,
	    MatSidenavModule,
	    MatSliderModule,
	    MatSlideToggleModule,
	    MatSnackBarModule,
	    MatSortModule,
	    MatTableModule,
	    MatTabsModule,
	    MatToolbarModule,
	    MatTooltipModule,
	    MatTreeModule,
	    BrowserModule,
	    BrowserAnimationsModule,
	    FormsModule,
	    HttpClientModule,
	    MatNativeDateModule,
	    ReactiveFormsModule,
	    HttpClientModule, 
	    AppRoutingModule, 
	    Ng2SmartTableModule, 
	    FormsModule,
	    ReactiveFormsModule, 
	    RecaptchaModule.forRoot(),
	    CustomFormsModule,
	    ToasterModule.forRoot(),
	    NgIdleKeepaliveModule.forRoot(),
	    NgxPermissionsModule.forRoot()
    ],
    providers: [AuthService],
    bootstrap: [AppComponent]
})
export class AppModule {}
